import { useState } from 'react';

interface Props {
  onLocated(position: { lat: number; lon: number }): void;
  onError(message: string): void;
}

export function LocateButton({ onLocated, onError }: Props) {
  const [busy, setBusy] = useState(false);

  const locate = () => {
    if (!('geolocation' in navigator)) {
      onError('Your browser can’t share your location. Try searching a postcode instead.');
      return;
    }
    setBusy(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setBusy(false);
        onLocated({ lat: position.coords.latitude, lon: position.coords.longitude });
      },
      (error) => {
        setBusy(false);
        onError(
          error.code === error.PERMISSION_DENIED
            ? 'Location is switched off for this site. Search a postcode instead, or allow location in your browser settings.'
            : 'Couldn’t find you just now. Try again, or search a postcode.',
        );
      },
      { enableHighAccuracy: false, timeout: 12_000, maximumAge: 60_000 },
    );
  };

  return (
    <button
      type="button"
      className="locate"
      onClick={locate}
      disabled={busy}
      aria-label={busy ? 'Finding your location' : 'Use my location'}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" className={busy ? 'spin' : undefined}>
        <circle cx="12" cy="12" r="3.5" fill="currentColor" />
        <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="2" />
        <path d="M12 1v4M12 19v4M1 12h4M19 12h4" stroke="currentColor" strokeWidth="2" />
      </svg>
    </button>
  );
}
